import React, { useEffect, useRef, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import SimpleAlert from '../components/SimpleAlert';
import DocumentFileViewer from '../components/DocmentFileViewer';
import DocViewer from 'react-doc-viewer';
// import CustomDocViewer from './components/CustomDocViewer';

// import { GlobalWorkerOptions } from 'pdfjs-dist';
// import jsPreviewPdf from "@js-preview/pdf";

// import DocViewer from "polaris-doc-viewer";

import { Document, Page } from 'react-pdf';

import PDFViewer from '../components/PDFViewer';

import { GlobalWorkerOptions } from 'pdfjs-dist';
import { Worker, Viewer } from "@react-pdf-viewer/core";
import "@react-pdf-viewer/core/lib/styles/index.css";
import { pdfjs } from 'react-pdf';

// 正确配置Worker路径，版本号一致
pdfjs.GlobalWorkerOptions.workerSrc = `${window.location.origin}/pdf.worker.min.js`;

export default function SignBefore({ }) {
   
// const pdfjsReady = usePDFJS();
  // ... 其他代码保持不变

  // 在打开预览时确保 PDF.js 已加载
//   const handleOpenFile = (item) => {
//     if (!pdfjsReady) {
//       setAlert({ open: true, message: '文档查看器加载中，请稍后...' });
//       return;
//     }
//     // ... 原有的打开逻辑
//   }; 

    const { search } = useLocation();
    const searchParams = new URLSearchParams(search);
    const [certifyId, setCertifyId] = useState('');
    const [alert, setAlert] = useState({ open: false, message: '' });
    const [files, setFiles] = useState([]);
    const [fileItem, setFileItem] = useState("");
    const [fileItemShow, setFileItemShow] = useState(false);
    const [fileType, setFileType] = useState('pdf');
    // const [docs,setDocs] = useState([]);
    const pdfForPreview = useRef();
    // const pdfForPreview = useRef(null);
    const parsedUrl = new URL('https://501351981.github.io/vue-office/examples/dist/static/test-files/test.pdf');
    // useEffect(() => {
    //     // 访问 DOM 元素
    //     if (pdfForPreview.current) {
    //          console.log('容器元素:', pdfForPreview.current);    
    //     }
    // }, []);
    
    const [pdfUrl, setPdfUrl] = useState();
    const [retryCount, setRetryCount] = useState(0);
    const [docs,setDocs] = useState([
        { uri: "https://rlrz.cqyz.com.cn/2025072805201027/signing/file-bab1bb1ed7-1755362968728.pdf"}
    ]);

    const documents = [
        { uri: "https://rlrz.cqyz.com.cn/2025072805201027/signing/file-bab1bb1ed7-1755362968728.pdf" }
    ];
    


    useEffect(() => {
        console.log("docs 已更新:", docs);
    }, [docs]);

    useEffect(() => {
        document.getElementById('my-zzj-footer').style.display = 'none';
        const cid = searchParams.get("certifyId");
        if (cid) {
            setCertifyId(cid);
        } else {
            setAlert({ open: true, message: '缺少认证参数，请重新进入签名流程' });
        }
    }, []);
    useEffect(() => {
        console.log('certifyId', certifyId)
        if (!certifyId) return;
        const token = localStorage.getItem('adminToken');
        const headers = {};
        if (token) {
            headers['Authorization'] = 'Bearer ' + token;
        }
        fetch(`/api/client/signBefore/${certifyId}`, {
            headers
        })
            .then(res => {
                if (res.status === 401 || res.status === 403) {
                    setAlert({ open: true, message: '您没有权限执行此操作' });
                    return null;
                }
                return res.json();
            })
            .then(res => {
                if (!res || !res.status) {
                    setAlert({ open: true, message: res.message || '未知错误' });
                    return
                }
                const { isNotSignFile, situationChecked, situationUrl, situationName,
                    resolutionChecked, resolutionUrl, resolutionName,
                    customize1Checked, customize1Url, customize1Name,
                    customize2Checked, customize2Url, customize2Name } = res.data;
                if (isNotSignFile === true) {
                    setAlert({ open: true, message: res.message || '当前不需要签名' });
                    return
                }
                const fileList = [];
                if (situationChecked) {
                    fileList.push({
                        fileUrl: situationUrl,
                        fileName: situationName,
                        fileType: '情况说明',
                        isLook: false
                    })
                }
                if (resolutionChecked) {
                    fileList.push({
                        fileUrl: resolutionUrl,
                        fileName: resolutionName,
                        fileType: '股东会决议',
                        isLook: false
                    })
                }
                if (customize1Checked) {
                    fileList.push({
                        fileUrl: customize1Url,
                        fileName: customize1Name,
                        fileType: '自定义文件1',
                        isLook: false
                    })
                }
                if (customize2Checked) {
                    fileList.push({
                        fileUrl: customize2Url,
                        fileName: customize2Name,
                        fileType: '自定义文件2',
                        isLook: false
                    })
                }
                setFiles(fileList);
            });
    }, [certifyId]);

    return (
        <div style={{
            maxWidth: '1200px',
            width: '100vw',
            minHeight: '100vh',
            fontFamily: 'Arial, sans-serif',
            display: 'flex',
            justifyContent: 'center'
        }}>
            <div style={{
                width: 'calc(100vw - 40px)',
                margin: '30px 0 50px',
                backgroundColor: '#ffffff',
                borderRadius: '15px',
                boxShadow: '5px 5px 5px 5px #eee',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center'
            }}>
                <img src="/icon-sign.png" style={{
                    height: '200px',
                    width: '200px'
                }} />
                <div style={{ fontSize: '20px', color: '#333', fontWeight: 'bold' }}>文件签章</div>
                <div style={{ marginTop: '7px', fontSize: '14px', color: '#666' }}>
                    有{files.length}份文件需要签名，请您仔细阅读：
                </div>
                <div style={{
                    width: 'calc(100% - 60px)',
                    padding: '15px 15px',
                    marginTop: '10px',
                    backgroundColor: '#d4edda',
                    border: '2px solid #c1e3c8',
                    borderRadius: '10px'
                }}>
                    {files && files.map((item, index) => (
                        <div key={item.fileUrl} style={{
                            width: '100%', padding: '5px 0',
                            display: 'flex', flexDirection: 'row', alignItems: 'center'
                        }}>
                            <div style={{ flex: '1', fontSize: '12px', fontWeight: '500' }}>{index + 1}、{item.fileName}</div>
                            <div style={{
                                padding: '3px 10px', fontSize: '11px', backgroundColor: item.isLook ? '#c8e2ca' : '#019fe6',
                                color: '#fff', borderRadius: '3px', marginLeft: '10px'
                            }}
                                onClick={async () => {

                                    setFileItemShow(true);
                                    

                                   
                                    // const response =  await fetch('https://rlrz.cqyz.com.cn/2025072805201027/signing/file-bab1bb1ed7-1755362968728.pdf');
                                    
                                    // const blob = await response.blob();

                                    // const url = URL.createObjectURL(blob);
                                    // setPdfUrl(url);

                                    // setTimeout(() => {
                                    //     console.log(pdfForPreview.current,'sssss')
                                    //     console.log(pdfForPreview,'bbbs')

                                    //     const myPdfPreviewer = jsPreviewPdf.init(pdfForPreview.current, {
                                    //         onError: (e)=>{
                                    //             console.log('发生错误', e)
                                    //         },
                                    //         onRendered: ()=>{
                                    //             console.log('渲染完成')
                                    //         }
                                    //     });
                                    //     myPdfPreviewer.preview('https://501351981.github.io/vue-office/examples/dist/static/test-files/test.pdf');
                                        
                                    // },0)
                                    // 将相对路径转换为完整的 HTTP URL
                                    // const baseUrl = 'https://rlrz.cqyz.com.cn'; // 你的网站域名
                                    // let baseUrl = "http://localhost:3000";
                                    
                                    // const fullUrl = item.fileUrl.startsWith('/') 
                                    //     ? `${baseUrl}${item.fileUrl}`
                                    //     : `${baseUrl}/${item.fileUrl}`;
                                    
                                    // console.log('完整文件URL:', fullUrl);
                                    
                                    // // 设置要预览的文档
                                    // const doc = {
                                    //     uri: fullUrl,
                                    //     fileType: item.fileUrl.split('.').pop().toLowerCase(),
                                    //     fileName: item.fileName
                                    // };
                                    
                                    // setDocs([doc]);
                                    // setFileItem(fullUrl);
                                    
                                    // window.open(item.fileUrl, '_blank', 'noopener,noreferrer');
                                    console.log(item)
                                    // setFileItem(item.fileUrl); // 这里替换成实际文件URL
                                    // setFileItemShow(true);
                                    // setDocs([{ uri: `https://rlrz.cqyz.com.cn/2025072805201027/signing/file-bab1bb1ed7-1755362968728.pdf` }]);
                                    // 设置文档预览
                                    // console.log(docs)

                                    if (item.fileUrl) {
                                        let fileList = JSON.parse(JSON.stringify(files));
                                        fileList = fileList.map(p => {
                                            if (p.fileUrl === item.fileUrl) {
                                                p.isLook = true;
                                            }
                                            return p;
                                        })
                                        setFiles(fileList);
                                        const ext = item.fileUrl.split('.').pop().toLowerCase();
                                        const isPdf = ['pdf'].includes(ext);
                                        const isWord = ['doc', 'docx'].includes(ext);
                                    //    setFileItem(item.fileUrl); // 这里换成实际文件地址
                                        setFileItemShow(true);
                                        if (isPdf) {
                                            setFileType("pdf");
                                        } else if (isWord) {
                                            setFileType("docx");
                                        }
                                    } else {
                                        setAlert({ open: true, message: '数据错误' });
                                    }

                                     setFileItem(item.fileUrl)
                                    
                                }}>
                                {item.isLook ? '已阅读' : '仔细阅读'}
                            </div>
                        </div>
                    ))}
                </div>
                {/* <iframe src="http://localhost:3000/2025072805201027/signing/file-72442eabb5-1755362386677.pdf"></iframe> */}

                    {/* 弹出框 */}
                {fileItemShow && (
                    <div
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: "rgba(0,0,0,0.6)",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        zIndex: 1000,
                    }}
                    >
                    <div
                        style={{
                        width: "95%",
                        height: "65%",
                        backgroundColor: "#fff",
                        borderRadius: "10px",
                        overflow: "auto",
                        padding: "10px",
                        display: "flex",
                        flexDirection: "column",
                        }}
                    >
                        {/* 关闭按钮 */}
                        <div style={{ padding: "10px", textAlign: "right" }}>
                            <text style={{
                            display: 'inline-block',
                            textAlign: 'left',
                            padding: '5px 5px',
                            fontSize: '20px',
                            color: '#888',
                            marginRight: '10vw'
                          }}>💡可放大屏幕阅读</text>
                        <button onClick={() => setFileItemShow(false)}>关闭</button>
                        </div>

                        {/* 文件预览 */}
                        {/* 文件预览 */}
                        <div className="flex-1 overflow-hidden" id='pdfForPreview' ref={pdfForPreview} style={{ flex: 1, borderTop: "1px solid #ccc", height: '100%', width: '100%' }}>
                            { fileType !== 'pdf' ? (
                                <DocumentFileViewer 
                                    fileUrl={getFullUrl(fileItem)}
                                    fileType={fileType}
                                />
                            ) : (
                                <Worker workerUrl={`${window.location.origin}/pdf.worker.min.js`}>
                                    <Viewer fileUrl={getFullUrl(fileItem)} />
                                </Worker>
                            ) }
                        </div>
                    </div>
                </div>
                )}
                {/* <iframe src={fileItem} style={{ width: '100%', height: '500px', border: 'none' }} ></iframe> */}
                <div style={{ width: 'calc(100% - 60px)', display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: '30px' }}>
                    <div style={{
                        flex: '1',
                        height: '40px',
                        backgroundColor: '#2c8cf0',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        margin: '0 10px 0 5px',
                        fontSize: '18px',
                        color: '#fff',
                        borderRadius: '7px'
                    }} onClick={() => {
                        if (files.filter(p => !p.isLook).length > 0) {
                            setAlert({ open: true, message: '请仔细阅读完所有文件内容' });
                            return;
                        }
                        if (!certifyId) {
                            setAlert({ open: true, message: '认证信息丢失，请重新进入签名流程' });
                            return;
                        }
                        window.location.href = `/signing?certifyId=${encodeURIComponent(certifyId)}`;
                    }}>同意办理&nbsp;&nbsp;我要签名</div>
                    <div style={{
                        width: '80px',
                        height: '40px',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        backgroundColor: '#6c757d',
                        color: '#fff',
                        borderRadius: '7px',
                        fontSize: '18px'
                    }} onClick={() => { window.location.href = `/` }}>不同意</div>
                </div>
                <div style={{
                    width: 'calc(100% - 60px)',
                    padding: '15px 15px 10px',
                    backgroundColor: '#f8f9fb',
                    border: '1px solid #e8e9eb',
                    borderRadius: '10px',
                    margin: '25px 0'
                }}>
                    <div style={{ width: '100%', display: 'flex', flexDirection: 'row', height: '30px', alignItems: 'center' }}>
                        <img src="/icon-gth.png" style={{
                            height: '15px',
                            width: '15px',
                            marginRight: '5px'
                        }} />
                        <div style={{ fontSize: '15px', fontWeight: 'bold' }}>说明</div>
                    </div>
                    <div style={{ fontSize: '11px', color: '#666' }}>
                        电子签名等同您本人亲笔签名，同意办理即意味您愿意承担因此可能产生的一切后果与责任
                    </div>
                </div>
            </div>
            <SimpleAlert open={alert.open} message={alert.message} onClose={() => setAlert({ ...alert, open: false })} />
        </div >
    );
}

// 辅助函数：统一生成可访问的文件完整 URL
function getFullUrl(url) {
  if (!url) return '';
  // 如果已经是完整地址，直接返回
  if (/^https?:\/\//i.test(url)) return url;
  return `https://rlrz.cqyz.com.cn/${url.replace(/^\//, '')}`;
}
